module.exports = __webpack_public_path__ + "Roboto-Light.bbe5f3827bc615de7ae4.woff";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Light.woff
// module id = ../../../../../src/assets/fonts/Roboto-Light.woff
// module chunks = styles